<template>
  <div class="d-ib">
    <el-badge is-dot :hidden="filtersEmpty()">
      <el-button
        type="primary"
        class="btn-main"
        icon="el-icon-search"
        @click="dialog = true"
      >
        Filters
      </el-button>
    </el-badge>
    <el-dialog
      title="Filters"
      :visible.sync="dialog"
      width="30%"
      top="3vh"
      :modal="false"
    >
      <el-switch
        v-model="active"
        :active-value="1"
        :inactive-value="2"
        active-color="#13ce66"
        :inactive-color="active === null ? '#dcdfe6' : '#ff4949'"
        active-text="Published"
        inactive-text="Not Published"
      ></el-switch>
      <el-input
        class="mt10"
        type="text"
        v-model="name"
        placeholder="Artist name"
        clearable
        @clear="filter()"
        @keyup.native.enter="filter()"
      />
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      name: '',
      active: 1
    }
  },
  methods: {
    ...mapActions('newReleasesArtists', ['read']),
    ...mapMutations('newReleasesArtists', ['setPage']),

    filter() {
      this.setPage(1)
      let filter_data = {
        name: this.name,
        active: this.active
      }
      localStorage.setItem(
        'artist_new_releases_filter',
        JSON.stringify(filter_data)
      )
      this.read(filter_data)
      this.filtersEmpty()
      this.dialog = false
    },

    filtersEmpty() {
      let ls = JSON.parse(localStorage.getItem('artist_new_releases_filter'))
      if (ls) {
        const { page, page_size, ...active_filters } = ls

        let f = Object.values(active_filters).filter(function(n) {
          return n > 0 || n != ''
        })

        if (f != null && f.length) return false
      }

      return true
    },

    clear() {
      this.name = ''
      this.active = 1
      localStorage.removeItem('artist_new_releases_filter')
      this.read()
    }
  }
}
</script>
